<template>
    <div
        v-if="entry.buchungen.length"
        class="d-flex justify-content-around"
    >
        <FiBuSumList
            v-if="showJaSums === 'true'"
            :filter="filter"
            :group_id="1"
        />
        <FiBuSumList
            v-if="showFurtherSums === 'true'"
            :filter="filter"
            :group_id="2"
        />
    </div>
</template>
<script>
import FiBuSumList from "@/components/FiBuSumList/FiBuSumList.vue"

export default {
    name: 'FiBuKontenblaetterSums',
    components: { FiBuSumList },
    props: ['entry'],
    computed: {
        pages() {
            return this.$store.getters.getPages;
        },
        filter() {
            const newFilter = {
                _to_date: this.pages.fibu_kontenblaetter.filter?._to_date,
                _from_date: this.pages.fibu_kontenblaetter.filter?._from_date,
                _buchungskonto_id: null,
                _finanzkonto_id: null,
                category: this.entry.category
            }

            if (this.pages.fibu_kontenblaetter.filter?.type === 'buchungskonto') {
                newFilter._buchungskonto_id = this.entry.buchungen[0].buchungskonto_id;
            } else {
                newFilter._finanzkonto_id = this.entry.buchungen[0].finanzkonto_id
            }

            return newFilter;
        },
        showJaSums() {
            return this.pages.fibu_kontenblaetter.filter?.showJaSums;
        },
        showFurtherSums() {
            return this.pages.fibu_kontenblaetter.filter?.showFurtherSums;
        }
    }
}
</script>